"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("../util");

var active = {
  inline: {
    outlineColor: function outlineColor(_a) {
      var color = _a.color;
      return color.bg;
    },
    cursor: function cursor(_a) {
      var disabled = _a.disabled;
      return disabled ? 'inherit' : 'pointer';
    },
    outlineWidth: function outlineWidth(_a) {
      var size = _a.size;
      return util_1.round(size / 5) + 'px';
    }
  },
  //prettier-ignore
  styles: util_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    user-select: none;\n    outline-offset: -2px;\n\n    ", " \n\n    ", " \n\n    ", "\n    \n    ", " \n  "], ["\n    user-select: none;\n    outline-offset: -2px;\n\n    ", " \n\n    ", " \n\n    ", "\n    \n    ", " \n  "])), function (_a) {
    var hover = _a.hover,
        bg = _a.bg,
        bgColor = _a.bgColor;
    return hover && bg && "\n\t\t\t&:hover{\n\t\t\t\tbackground:" + bgColor.nudge(-0.15 * util_1.getScalar(hover)).bg + " !important;\n\t\t\t}\n    ";
  }, function (_a) {
    var active = _a.active,
        hover = _a.hover,
        bg = _a.bg,
        bgColor = _a.bgColor;
    return active && bg && "\n      background:" + bgColor.nudge(-0.15 * util_1.getScalar(hover)).bg + " !important;\n    ";
  }, function (_a) {
    var hover = _a.hover,
        color = _a.color,
        bg = _a.bg;
    return hover && "\n\t\t\t&:hover{\n\t\t\t\tcolor:" + color.nudge((bg ? -0.2 : 0.8) * util_1.getScalar(hover)).fg + " !important;\n\t\t\t}\n    ";
  }, function (_a) {
    var active = _a.active,
        hover = _a.hover,
        bg = _a.bg,
        color = _a.color;
    return active && "\n      color:" + color.nudge((bg ? -0.2 : 0.8) * util_1.getScalar(hover)).fg + " !important;\n    ";
  }),
  props: {
    hover: {
      default: true
    },
    active: {
      default: false
    }
  }
};
exports.default = active;
var templateObject_1;